import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '@usimweb/core/services';
import { Part, Meshing } from '@usimweb/core/models';

import { InputType } from '../../../../core/enums/inpuTypeEnum';
import { SIMULATIONTYPE } from '../../../../core/enums/simulationTypeEnum';

import { BoundingBoxService } from '../../../../core/services/bounding-box/bounding-box.service';
import { DialogService } from '@usimweb/ui/dialogs';
import { CadDetailDialogComponent } from 'apps/foaming/src/app/dialogs/cad-detail-dialog/cad-detail-dialog.component';
import { AddCadDialogComponent } from 'apps/foaming/src/app/dialogs/add-cad-dialog/add-cad-dialog.component';

@Component({
    selector: 'app-part',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './part.component.html',
    styleUrls: ['./part.component.scss'],
    standalone: false
})
export class PartComponent implements OnInit, OnChanges {
  @Input() meshes: Meshing[] = [];

  @Input() part: Part = {
    modelKey: '',
    gravityX: 0,
    gravityY: 0,
    gravityZ: 0,
    volume: 0,
    cadModel: '',
    partId: '',
    name: '',
    credits: 0,
  };

  @Output() updatePart: EventEmitter<any> = new EventEmitter<any>();

  @Output() openModel: EventEmitter<any> = new EventEmitter<any>();

  @Output() requestModel: EventEmitter<any> = new EventEmitter<any>();

  @Output() simulationTypeChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() stepperChange: EventEmitter<any> = new EventEmitter<any>();

  private uuid: string = '';

  public simulationTypeEnum = SIMULATIONTYPE;

  public simulationTypes = [
    { key: SIMULATIONTYPE.RT, value: 'RT' },
    { key: SIMULATIONTYPE.VARIOTHERM, value: 'Variotherm' },
  ];
  public simulationType = SIMULATIONTYPE.RT;
  public inputType = InputType;
  public keyValueMeshes = [];
  public gravityStr: string = '';

  public keySimType = 'key';
  public valueSimType = 'value';
  public cadToolTip = 'Select or create CAD geometry with the "plus" button...';

  constructor(
    private boundingBoxService: BoundingBoxService,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.uuid = this.route.snapshot.paramMap.get('id')?.toString() || '';

    if (!this.route.snapshot.paramMap.get('id2')?.toString()) {
      this.checkGeometries();
    }
  }

  ngOnInit(): void {
    this.part = {
      cadModel: 'No selected CAD geometry',
      modelKey: '',
      gravityX: 0,
      gravityY: 0,
      gravityZ: 0,
      volume: 0,
      partId: '',
      name: '',
      credits: 0,
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.part && changes['part']) {
      const part = changes['part'].currentValue as Part;
      this.gravityStr = part.gravityX + ', ' + part.gravityY + ', ' + part.gravityZ;
    }
  }

  private checkGeometries() {
    const subscription = this.apiService.getGeometries(this.uuid, false).subscribe((response: Meshing[]) => {
      subscription.unsubscribe();

      if (response.length > 0) {
        setTimeout(() => {
          this.openCadDetailDialog();
        }, 250);
      } else {
        setTimeout(() => {
          this.openAddCadDialog();
        }, 250);
      }
    });
  }

  private updateStepper() {
    if (this.part.modelKey && this.simulationType === this.simulationTypeEnum.VARIOTHERM) {
      this.stepperChange.emit(true);
    } else {
      this.stepperChange.emit(false);
    }
  }

  public blur() {
    this.updatePart.emit(this.part);
  }

  public simulatioTypeChanged(value: SIMULATIONTYPE) {
    if (value === SIMULATIONTYPE.RT) {
      this.simulationType = this.simulationTypeEnum.RT;
    }
    if (value === SIMULATIONTYPE.VARIOTHERM) {
      this.simulationType = this.simulationTypeEnum.VARIOTHERM;
    }

    this.updateStepper();

    this.simulationTypeChanged.emit(this.simulationType);
  }

  public openCadDetailDialog() {
    this.dialogService.flush();
    this.dialogService
      .openContentDialog(CadDetailDialogComponent, { uuid: this.uuid }, 'Select a model', '', 70)
      .subscribe((data) => {
        if (data && !('openDialog' in data)) {
          this.part.cadModel = data.name;
          this.part.modelKey = data.id;

          this.updateStepper();
          //this.boundingBoxService.clearPartsCustomInfo();

          this.requestModel.emit(data);
        } else if (!data) {
        } else {
          this.openAddCadDialog();
        }
      });
  }

  public openAddCadDialog() {
    this.dialogService
      .openContentDialog(AddCadDialogComponent, { uuid: this.uuid }, 'Add CAD geometry', 'Select', 70)
      .subscribe((data) => {
        if (data) {
          this.openModel.emit(data);
        }
      });
  }
}
